/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import APIURLMaker from "../utils/APIURLMaker";
import axios from "axios";
import { getAuthorizationHeaders, getBearerToken } from "./authToken";

const APINEW = {
  buildHeaders: (additionalHeaders = {}) => {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      ...getAuthorizationHeaders(),
      ...additionalHeaders,
    };
  },
  async request(endpoint, options = {}) {
    try {
      const url = APIURLMaker(endpoint);
      const headers = this.buildHeaders(options.headers);

      const response = await axios({
        url: url,
        method: options.method || "GET", // Default to GET if no method is provided
        headers: headers,
        data: options.body || options.data, // Use options.body or options.data for POST/PATCH/PUT methods
      });

      // Token expiry is now handled by the axios interceptor in axiosConfig.js
      return response.data; // Axios automatically parses the response as JSON
    } catch (error) {
      console.error("API Request Error:", error);
      throw error;
    }
  },

  sse: {
    currentConnection: null,

    connect: (onMessage, onError) => {
      if (APINEW.sse.currentConnection) {
        console.log("Closing existing SSE connection");
        this.sse.currentConnection.close();
        this.sse.currentConnection = null;
      }

      const token = getBearerToken();
      const baseUrl = `${process.env.REACT_APP_API_PROTOCOL}://${
        process.env.REACT_APP_API_SERVER
      }${
        process.env.REACT_APP_API_PORT
          ? `:${process.env.REACT_APP_API_PORT}`
          : ""
      }`;

      const eventSource = new EventSource(
        `${baseUrl}/api/events?category=TEST&token=${token}`,
        {
          withCredentials: false,
          retry: false,
        }
      );

      APINEW.sse.currentConnection = eventSource;

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        onMessage(data);
      };

      eventSource.onerror = (error) => {
        console.error("SSE Error:", error);
        if (onError) onError(error);
      };

      return eventSource;
    },
  },
};

export default APINEW;
